import { AlertCircle, CheckCircle2 } from 'lucide-react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            duration={2000}
            theme="system"
            className="text-lp-dark1"
            icons={{
                success: <CheckCircle2 className="w-4 h-4 text-lp-green stroke-2" />,
                error: <AlertCircle className="w-4 h-4 text-lp-red" />,
                warning: <AlertCircle className="w-4 h-4 text-lp-yellow" />,
            }}
            toastOptions={{
                classNames: {
                    success: 'text-lp-green text-sm',
                    error: 'text-lp-red text-sm',
                    warning: 'text-lp-yellow text-sm',
                },
            }}
            {...props}
        />
    )
}

export { Toaster }
